@if( !!markdownData ) {
<markdown [disableSanitizer]="true" (error)="onError($event.toString())">{{markdownData}}</markdown>
}